import { ChangeDetectionStrategy, Component, Input, input, output } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-grid-page-size-selector',
    templateUrl: './grid-page-size-selector.component.html',
    styleUrls: ['./grid-page-size-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatFormField,
        MatSelect,
        ReactiveFormsModule,
        FormsModule,
        MatOption,
        TranslatePipe,
    ]
})
export class GridPageSizeSelectorComponent {
  private _availablePageSizes: number[];

  readonly disabled = input(false);
  readonly pageSize = input<number>(undefined);

  get availablePageSizes() {
    return this._availablePageSizes;
  }

  @Input() set availablePageSizes(pageSizes: number[]) {
    this._availablePageSizes = Array.from(new Set(pageSizes.concat(this.pageSize()))).sort((a, b) => a - b);
  }

  readonly pageSizeChange = output<number>();
}
